// extracted by mini-css-extract-plugin
export default {"dataGridContainer":"TeamList_dataGridContainer__D5szl","title":"TeamList_title__+f7Yi","settingsBtn":"TeamList_settingsBtn__sFKEl"};